import Vue from 'vue'
import { GET_SUB_SECTORS, ERROR_XHR } from '../mutation-types.js'

export const getSubSectors = ({ dispatch }, sectorId) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get(`sector/${sectorId}/subsector`)
      .then(
        (response) => {
          dispatch(GET_SUB_SECTORS, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject(response)
        })
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/subSectorsActions.js